import { render } from "./permissions.vue?vue&type=template&id=5ec8fe76&scoped=true"
import script from "./permissions.vue?vue&type=script&lang=js"
export * from "./permissions.vue?vue&type=script&lang=js"

import "./permissions.vue?vue&type=style&index=0&id=5ec8fe76&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec8fe76"]])

export default __exports__